/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export type DeviceModelIncidentRulesControllerFindOnePathParameters = {
  clientId?: string;
  makerId: string;
  modelId: string;
  ruleId: string;
};
